import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HUBS } from "@/lib/seoHubs";

export const HomeServices = () => (
  <section data-testid="home-services" className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
    <div className="text-[10px] uppercase tracking-[0.25em] font-mono text-[#E0262C] mb-3">Servizi</div>
    <h2 className="font-display text-3xl sm:text-4xl leading-tight mb-8 max-w-[28ch]">SEO locale, campagne ADV e social: cosa facciamo</h2>
    <ul className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#cfd6d9] border border-[#cfd6d9]">
      {HUBS.map((h) => (
        <li key={h.slug}>
          <Link to={`/${h.slug}`} data-testid={`home-service-${h.slug}`} className="group h-full flex flex-col bg-white p-5 transition-colors hover:bg-[#09090b] hover:text-white">
            <h3 className="font-display text-lg leading-tight flex items-start justify-between gap-2">{h.title.split(" | ")[0]}<ArrowUpRight className="w-4 h-4 shrink-0 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></h3>
            <p className="mt-2 text-xs leading-relaxed text-[#5b6168] group-hover:text-[#c4c9ce]">{h.title.split(" | ")[1]}</p>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);
